import { useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authApi } from '../api/auth';
import { Btn } from '../components/Btn';
import { Logo } from '../components/Logo';
import type { HttpError } from '../api/client';

export function VerifyEmailPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const ranRef = useRef(false);

  const verify = useMutation({
    mutationFn: () => authApi.verifyEmail(token!),
  });

  useEffect(() => {
    if (!token || ranRef.current) return;
    ranRef.current = true;
    verify.mutate();
  }, [token, verify]);

  const errMsg = verify.isError
    ? ((verify.error as HttpError).body?.message ?? 'Nie udało się aktywować konta.')
    : null;

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#fbfaf6',
        color: '#0f1e3d',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
      }}
    >
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ marginBottom: 28 }}>
          <Logo size={56} />
        </div>

        <div
          style={{
            fontSize: 12,
            color: '#5b6578',
            letterSpacing: '.08em',
            fontWeight: 600,
            textTransform: 'uppercase',
          }}
        >
          Aktywacja konta
        </div>
        <h2 className="serif" style={{ fontSize: 32, fontWeight: 700, margin: '6px 0 16px', letterSpacing: '-0.02em' }}>
          {verify.isPending && 'Aktywujemy konto…'}
          {verify.isSuccess && 'Konto aktywne!'}
          {verify.isError && 'Coś poszło nie tak'}
        </h2>

        {verify.isPending && (
          <div style={{ fontSize: 14, color: '#5b6578' }}>
            Sprawdzamy link aktywacyjny. Sekundka.
          </div>
        )}

        {verify.isSuccess && (
          <>
            <div
              style={{
                padding: 14,
                background: 'rgba(31,157,85,.1)',
                color: '#0f6b34',
                borderRadius: 10,
                fontSize: 13,
                lineHeight: 1.5,
                marginBottom: 18,
              }}
            >
              Twoje konto zostało aktywowane. Możesz się teraz zalogować.
            </div>
            <Btn variant="primary" size="lg" fullWidth onClick={() => navigate('/login')}>
              Przejdź do logowania
            </Btn>
          </>
        )}

        {verify.isError && (
          <>
            <div
              style={{
                padding: 14,
                background: 'rgba(208,70,60,.08)',
                color: '#8a2a22',
                borderRadius: 10,
                fontSize: 13,
                lineHeight: 1.5,
                marginBottom: 18,
              }}
            >
              {errMsg}
            </div>
            <Btn variant="primary" size="lg" fullWidth onClick={() => navigate('/login')}>
              Wróć do logowania
            </Btn>
            <div style={{ marginTop: 14, textAlign: 'center', fontSize: 12, color: '#5b6578' }}>
              Link mógł wygasnąć — zaloguj się, a poprosimy Cię o wysłanie nowego.
            </div>
          </>
        )}

        {!verify.isError && !verify.isSuccess && (
          <div style={{ marginTop: 18, textAlign: 'center', fontSize: 13 }}>
            <Link to="/login" style={{ color: '#5b6578', textDecoration: 'none' }}>
              Wróć do logowania
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
